import { createContext } from "react";

const SociosContext = createContext({});

export default SociosContext;
